import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { isDev } from "../../../../../common/envConfig";

const NewtonContext = createContext(null);

export function NewtonProvider({ children }) {
  const [messagesHistory, setMessagesHistory] = useState([]);

  const [message, setMessage] = useState("");
  const [messageHtml, setMessageHtml] = useState("");

  const [attachedFiles, setAttachedFiles] = useState([]); // File[]

  const [llmEnv, setLlmEnv] = useState(isDev ? "qa" : "prod");

  const [sessionId, setSessionId] = useState(null);

  const [isNewtonOpen, setIsNewtonOpen] = useState(false);
  const [pendingSessionId, setPendingSessionId] = useState(null);

  const [adminOverrideUserId, setAdminOverrideUserId] = useState("");

  // Video metadata state
  const [videoFile, setVideoFile] = useState(null);
  const [selectedLibraryVideo, setSelectedLibraryVideo] = useState(null);

  const [isMetadataOpen, setIsMetadataOpen] = useState(false);

  const [videoMetadata, setVideoMetadata] = useState({
    club: "7I",
    gender: "MALE",
    swingIsLeftHanded: false,
    heightInInches: 63,
    swingAngle: "FaceOn",
    fps: 120,
  });

  const value = useMemo(
    () => ({
      // state
      messagesHistory,
      attachedFiles,
      message,
      messageHtml,
      // video metadata state
      videoFile,
      selectedLibraryVideo,
      isMetadataOpen,
      videoMetadata,
      // setters (expose raw setters)
      setMessagesHistory,
      setMessage,
      setMessageHtml,
      setAttachedFiles,
      setLlmEnv,
      llmEnv,
      sessionId,
      setSessionId,
      isNewtonOpen,
      setIsNewtonOpen,
      pendingSessionId,
      setPendingSessionId,
      adminOverrideUserId,
      setAdminOverrideUserId,
      // video metadata setters
      setVideoFile,
      setSelectedLibraryVideo,
      setIsMetadataOpen,
      setVideoMetadata,
      // simple ui toggles
    }),
    [
      messagesHistory,
      message,
      messageHtml,
      attachedFiles,
      llmEnv,
      sessionId,
      isNewtonOpen,
      pendingSessionId,
      adminOverrideUserId,
      videoFile,
      selectedLibraryVideo,
      isMetadataOpen,
      videoMetadata,
    ],
  );

  return (
    <NewtonContext.Provider value={value}>{children}</NewtonContext.Provider>
  );
}

export function useNewton() {
  const ctx = useContext(NewtonContext);
  if (!ctx) throw new Error("useNewton must be used within <NewtonProvider>");
  return ctx;
}
